// libs
import { connect } from 'react-redux';

// redux selectors
import { isUserFetching as _isUserFetching } from 'shared/store/app/selectors';
import { isLoggedIn as _isLoggedIn } from 'store/app/selectors';
import { setHeaderOptions, resetHeaderOptions, hideFooter } from 'shared/store/app/actions';

// components
import MyAccount from './MyAccount';

const mapStateToProps = (state: any) => {
  return {
    isUserFetching: _isUserFetching(state),
    isLoggedIn: _isLoggedIn(state),
  };
};

const mapDispatchToProps = {
  resetHeaderOptions,
  setHeaderOptions,
  hideFooter,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAccount);
